var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{staticStyle:{"padding":"0"},attrs:{"height":"240"}},[_c('Header')],1),_c('el-main',{staticStyle:{"width":"85%","min-height":"70vh","margin":"0 auto","padding":"0"}},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('el-footer',{staticStyle:{"padding":"0","margin-top":"20px"}},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }